import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export interface IPriceParam {
    price: number;
}

export const priceSumAction = actionCreator<IPriceParam>('priceSum');
